/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable react/no-danger */
/* eslint-disable no-unused-expressions */
import React, { useState } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Box, Flex, Button, Text } from "rebass/styled-components"

import SEO from "../components/Seo"
import withTranslation from "../i18n/withTranslation"
import BlogHero from "../components/BlogHero"
import BlogThumb from "../components/BlogThumb"

import { theme } from "../components/Layout"

const PostsWrapper = styled.section`
  display: flex;
  width: 1120px;
  max-width: 100%;
  margin: 0 auto;
  flex-direction: row;
  flex-wrap: wrap;

  > article {
    flex: 0 0 50%;
  }

  @media screen and (max-width: ${theme.breakpoints[1]}) {
    > article {
      flex: 0 0 100%;
    }

    margin: 50px 0;
  }
`

function LoadMore({ t, i18n, pageContext: { edges } }) {
  const [hasMore, setMore] = useState(edges.length > 5)
  const [currentList, addToList] = useState([...edges.slice(0, 5)])

  const loadEdges = () => {
    const currentLength = currentList.length
    const canPaginate = currentLength < edges.length
    const nextEdges = canPaginate
      ? edges.slice(currentLength, currentLength + 2)
      : []

    addToList([...currentList, ...nextEdges])

    const more = [...currentList, ...nextEdges] < edges.length
    setMore(more)
  }

  const loadMore = () => {
    loadEdges()
  }

  const firstPost = edges.length > 0 ? currentList[0].node : null

  const { language } = i18n

  return (
    <>
      <SEO title="Blog" />
      {edges.length <= 0 ? (
        <Text as="h3" sx={{ textAlign: "center", py: 6, my: 6 }}>
          {t("blog.noPosts")}
        </Text>
      ) : (
        <>
          <Flex sx={{ flex: "100% 0 0" }}>
            <BlogHero
              slug={firstPost.fields.slug}
              title={
                language === "es_MX"
                  ? firstPost.frontmatter.titleES
                  : firstPost.frontmatter.title
              }
              body={firstPost.html}
              language={language}
              featuredImage={firstPost.frontmatter.featured}
              publishDate={firstPost.frontmatter.publish}
            />
          </Flex>
          <PostsWrapper>
            {currentList.map(
              ({ node: { frontmatter, excerpt, id, fields } }, idx) => {
                if (idx !== 0) {
                  return (
                    <BlogThumb
                      key={`fields-${id}`}
                      index={id + 1}
                      slug={fields.slug}
                      title={
                        language === "es_MX"
                          ? frontmatter.titleES
                          : frontmatter.title
                      }
                      bodyES={frontmatter.bodyES}
                      publishDate={frontmatter.publish}
                      excerpt={excerpt}
                      featuredImage={frontmatter.featured}
                      language={language}
                    />
                  )
                }
              }
            )}

            {hasMore && (
              <Box sx={{ textAlign: "center" }} width={1} py={5}>
                <Button onClick={loadMore} type="button">
                  {t("blog.loadmore")}
                </Button>
              </Box>
            )}
          </PostsWrapper>
        </>
      )}
    </>
  )
}

function LoadMoreTemplate(props) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <LoadMore {...props} />
}

LoadMore.propTypes = {
  pageContext: PropTypes.shape({
    edges: PropTypes.arrayOf(
      PropTypes.shape({
        frontmatter: PropTypes.shape({
          title: PropTypes.string,
          featured: PropTypes.string,
        }),
        excerpt: PropTypes.string,
        id: PropTypes.number,
      })
    ),
  }),
  t: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    language: PropTypes.string,
  }).isRequired,
}

export default withTranslation(LoadMoreTemplate)
